export default __webpack_public_path__ + "static/media/Proxima-Nova-Bold-It.fadb7d76.ttf";